module.exports = __webpack_public_path__ + "static/img/productHot1.aaf22358.png";